import type { JSX } from "react";

import Button from "@mui/material/Button";

import { language } from "@/Router";
import {
  useConfigurationServicePostCustomApiConfigurationPublicShoppingCartShow,
  useConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandard,
  useConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfigurator,
  useConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnell,
} from "@/openapi/api-cpq/queries/queries";

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

export function DebugLoginButtons(): JSX.Element {
  const userSessionId =
    window.sessionStorage.getItem("userSessionId") ??
    urlParams.get("userSessionId");

  const { mutate: showShoppingCart } =
    useConfigurationServicePostCustomApiConfigurationPublicShoppingCartShow();

  const { mutate: startStandardConfigurator } =
    useConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandard();

  const { mutate: startProfiConfigurator } =
    useConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfigurator();

  const { mutate: startProfiSchnellConfigurator } =
    useConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnell();

  function getUserSessionIdStandard(geolocationId: string): void {
    startStandardConfigurator(
      {
        requestBody: {
          localeId:
            geolocationId === "EN" || geolocationId === "NL"
              ? "en-GB"
              : "de-DE",
          userToken: "",
          userSessionId: "exampleSessionID",
          externalId: "exampleID",
          geolocationId,
        },
      },
      {
        onSuccess: (data) => {
          console.log({ data });
          const queryString = data.redirectUrl?.split("?")[1];
          const urlParams = new URLSearchParams(queryString);
          const userSessionId = urlParams.get("userSessionId");
          const cfgSessionId = urlParams.get("cfgSessionId");
          const language = urlParams.get("language");

          if (userSessionId) {
            window.sessionStorage.setItem("userSessionId", userSessionId);
          }
          if (cfgSessionId) {
            window.sessionStorage.setItem("cfgSessionId", cfgSessionId);
          }
          if (language) {
            const cfgObjectId = "CFG_KONFIG_STANDARD";
            window.location.replace(
              "/?cfgObjectId=" + cfgObjectId + "&language=" + language,
            );
          }
        },
        onError: (error) => {
          console.error("Request failed:", error);
        },
      },
    );
  }

  function getUserSessionIdProfi(geolocationId: string): void {
    startProfiConfigurator(
      {
        requestBody: {
          localeId: geolocationId === "EN" ? "en-GB" : "de-DE",
          userToken: "",
          userSessionId: "exampleSessionID",
          geolocationId,
          productSegment: "SRT",
        },
      },
      {
        onSuccess: (data) => {
          console.log({ data });
          const queryString = data.redirectUrl?.split("?")[1];
          const urlParams = new URLSearchParams(queryString);
          const userSessionId = urlParams.get("userSessionId");
          const cfgSessionId = urlParams.get("cfgSessionId");
          const language = urlParams.get("language");

          if (userSessionId) {
            window.sessionStorage.setItem("userSessionId", userSessionId);
          }
          if (cfgSessionId) {
            window.sessionStorage.setItem("cfgSessionId", cfgSessionId);
          }
          if (language) {
            const cfgObjectId = "CFG_PROFI_KONFIGURATOR";
            window.location.replace(
              "/?cfgObjectId=" + cfgObjectId + "&language=" + language,
            );
          }
        },
        onError: (error) => {
          console.error("Request failed:", error);
        },
      },
    );
  }

  function getUserSessionIdProfiSchnell(
    geolocationId: string,
    productSegment: string,
  ): void {
    startProfiSchnellConfigurator(
      {
        requestBody: {
          localeId: geolocationId === "EN" ? "en-GB" : "de-DE",
          userToken: "",
          userSessionId: "exampleSessionID",
          geolocationId,
          productSegment,
        },
      },
      {
        onSuccess: (data) => {
          const queryString = data.redirectUrl?.split("?")[1];
          const urlParams = new URLSearchParams(queryString);
          const userSessionId = urlParams.get("userSessionId");
          const cfgSessionId = urlParams.get("cfgSessionId");
          const fastConfiguration = urlParams.get("schnellkonfigurator");
          const language = urlParams.get("language");

          if (userSessionId) {
            window.sessionStorage.setItem("userSessionId", userSessionId);
          }
          if (cfgSessionId) {
            window.sessionStorage.setItem("cfgSessionId", cfgSessionId);
          }
          if (fastConfiguration) {
            window.sessionStorage.setItem(
              "fastConfiguration",
              fastConfiguration,
            );
            const cfgObjectId = "CFG_PROFI_KONFIGURATOR";
            window.location.replace(
              "/?cfgObjectId=" +
                cfgObjectId +
                "&schnellkonfigurator=" +
                fastConfiguration +
                "&language=" +
                language,
            );
          }
        },
        onError: (error) => {
          console.error("Request failed:", error);
        },
      },
    );
  }

  function redirectToShoppingCart(userSessionId: string): void {
    showShoppingCart(
      {
        requestBody: {
          userSessionId: userSessionId,
          localeId: language ? language : "de-DE",
        },
      },
      {
        onSuccess: (data) => {
          const queryString = data.redirectUrl?.split("/cpq")[1];
          console.log(data.redirectUrl);
          window.location.href = "/cpq" + queryString;
        },
        onError: (error) => {
          console.error("Request failed:", error);
        },
      },
    );
  }

  function resetSessionStorage(): void {
    window.sessionStorage.removeItem("userSessionId");
    window.sessionStorage.removeItem("cfgSessionId");
    window.sessionStorage.removeItem("fastConfiguration");
    window.location.replace("/");
  }

  return (
    <>
      {userSessionId ? (
        <>
          <Button
            sx={{ marginLeft: "2rem" }}
            onClick={() => redirectToShoppingCart(userSessionId)}
          >
            Sammelkorb anzeigen
          </Button>
          <Button sx={{ marginLeft: "2rem" }} onClick={resetSessionStorage}>
            Logout
          </Button>
        </>
      ) : (
        <>
          <Button
            sx={{ marginLeft: "2rem" }}
            onClick={() => getUserSessionIdStandard("DE")}
          >
            Login Standard (DE)
          </Button>
          <Button
            sx={{ marginLeft: "2rem" }}
            onClick={() => getUserSessionIdStandard("NL")}
          >
            Login Standard (NL)
          </Button>
          <Button
            sx={{ marginLeft: "2rem" }}
            onClick={() => getUserSessionIdStandard("EN")}
          >
            Login Standard (EN)
          </Button>
          <Button
            sx={{ marginLeft: "2rem" }}
            onClick={() => getUserSessionIdProfi("DE")}
          >
            Login Profi (DE)
          </Button>
          <Button
            sx={{ marginLeft: "2rem" }}
            onClick={() => getUserSessionIdProfi("NL")}
          >
            Login Profi (NL)
          </Button>
          <Button
            sx={{ marginLeft: "2rem" }}
            onClick={() => getUserSessionIdProfi("EN")}
          >
            Login Profi (EN)
          </Button>
          <Button
            sx={{ marginLeft: "2rem" }}
            onClick={() => getUserSessionIdProfiSchnell("DE", "SRT")}
          >
            Login Profi Schnellkonfiguration (DE, SRT)
          </Button>
          <Button
            sx={{ marginLeft: "2rem" }}
            onClick={() => getUserSessionIdProfiSchnell("EN", "SRT")}
          >
            Login Profi Schnellkonfiguration (EN, SRT)
          </Button>
          <Button
            sx={{ marginLeft: "2rem" }}
            onClick={() => getUserSessionIdProfiSchnell("DE", "SDT")}
          >
            Login Profi Schnellkonfiguration (DE, SDT)
          </Button>
        </>
      )}
    </>
  );
}
